/**
 * 菜品分类（固定枚举，不做可增删后台）
 */
export const CATEGORIES = [
  { value: 'hard', label: '硬菜' },
  { value: 'normal', label: '普通菜' },
  { value: 'dessert', label: '点心' },
  { value: 'fruit', label: '水果' },
  { value: 'staple', label: '主食' },
  { value: 'seasonal', label: '时令蔬菜' },
  { value: 'wei', label: '煨菜' }
]

export const CATEGORY_MAP = CATEGORIES.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

/** 配菜时必须各有 1 道的分类 */
export const REQUIRED_SINGLE_CATEGORIES = ['hard', 'dessert', 'fruit', 'staple']

export function categoryLabel(value) {
  return CATEGORY_MAP[value] || value || '未分类'
}

export function isValidCategory(value) {
  return Boolean(CATEGORY_MAP[value])
}

/** 表格导入：中文分类名或英文 value 都能识别 */
export function categoryFromLabel(text) {
  const raw = String(text || '').trim()
  if (!raw) return ''
  if (isValidCategory(raw)) return raw
  const found = CATEGORIES.find((item) => item.label === raw)
  return found ? found.value : ''
}
